import React, { useState, useContext, useEffect } from "react";
import { Alert, Button, Card, Col, Container, Row } from "react-bootstrap";
import _ from "lodash";
import { Link, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import ContextApp from "../../../../core/contexts/context.app";
import ApiUserPayment from "../../../../core/api/api.userPayment";
import ServiceStorage from "../../../../core/services/service.storage";
import DottedLoadingData from "../../_Components/DottedLoadingData";
import MessageBox from "./componentAfterPay/MessageBox";
import { IconErrorCircle } from "../../../../_metronic/css/icons";

function AfterPayIndex() {
  const location = useLocation();
  const [itemData, setItemData] = useState();
  const [loadingData, setLoadingData] = useState(true);
  //const params = queryString.parse(location.search);
  const params = new URLSearchParams(window.location.search);
  const ctx = useContext(ContextApp);

  useEffect(() => {
    (async () => {
      try {
        // user : 091544444444
        // http://localhost:9000/afterPay?bid=7016&pid=15025
        //دریافت لیست نقش ها
        const response = await ApiUserPayment.getPaymentResult({
          pid: params?.get("pid"),
        });

        if (!_.isEmpty(response) && response.succeeded) {
          setItemData(response.data);
          setLoadingData(false);
          // در صورت تغییر مبلغ کیف پول مبلغ کیف پول ویرایش شود
          if (
            _.isNumber(response.data.userWalletRiallBalance) &&
            response.data.userWalletRiallBalance >= 0
          ) {
            //دریافت اطلاعات کاربر
            let userInfo = ServiceStorage.getUserInfo();
            if (userInfo != null) {
              userInfo.walletRiallBalance =
                response.data.userWalletRiallBalance;
              userInfo.walletAvailableRiallBalance =
                response.data.userWalletAvailableRiallBalance;
              //ویرایش اطلاعات کاربر
              ServiceStorage.setUserInfo(userInfo);
              ctx.setUserInfo(userInfo);
            }
          }
        } else {
          //toast.configure();
          setLoadingData(false);
          toast(response?.message);
        }
      } catch (error) {
        setLoadingData(false);
      } finally {
      }
    })();
    return () => {};
  }, []);

  console.log("dd", itemData);
  return (
    <>
      <div className=" py-4">
        {loadingData ? (
          <div className="pt-5 text-center">
            <div className="pt-5">
              {/* <DottedLoadingData withText="true" /> */} درحال دریافت اطلاعات ...
            </div>
          </div>
        ) : (
          <div className="mt-5 mx-auto">
            {itemData?.boxId == 3 ? (
              <div className="my-auto">
                {/*  در بازگشت از بانک به مشکل بر خورد کرده*/}
                <MessageBox
                  boxType={3}
                  descTitleBox="عملیات پرداخت انجام نشد."
                  titleBox="عملیات ناموفق "
                  resultType="error"
                  errorText={itemData.errorText}
                />
              </div>
            ) : itemData?.boxId == 4 ? (
              <div className="my-auto">
                {/* برای شارژ کیف پول بوده */}
                <MessageBox
                  boxType={4}
                  descTitleBox="پرداخت شما باموفقیت انجام شد"
                  titleBox="عملیات موفق "
                  resultType="success"
                  amount={itemData.amount}
                  referenceId={itemData.referenceId}
                  userWalletRiallBalance={itemData.userWalletRiallBalance}
                  errorText={itemData.errorText}
                />
              </div>
            ) : (
              <MessageBox
                boxType={5}
                descTitleBox="  اشکال در روند اجرا"
                titleBox="عملیات ناموفق "
                resultType="error"
              />
            )}
          </div>
        )}
      </div>
    </>
  );
}

export default AfterPayIndex;
